
<div class="search-box" (click)="open = !open" [ngClass]="{'open-search-box': open}">
  <input placeholder="Search..." name="search" [(ngModel)]="search" (ngModelChange)="textChange($event)" (click)="$event.stopPropagation()"/><i class="fa fa-search" [ngClass]="{'text-info': search}"></i>
</div>